"use client";;
import useSocialUpdates from "@/app/hooks/useSocialUpdates";
import { font_title_secularOne } from "@/app/ui/fonts";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/app/ui/imported/tooltip";
import NumberTicker from "@/app/ui/magicui/number-ticker";
import Spinner from "@/app/ui/utils/Spinner";
import { cn, GoogleAnalyticsEvent, sleep } from "@/lib/utils";
import { useEffect, useState } from "react";

export interface SubCountProps {
    ytid: string,
    initialCount: number,
    className?: string,
}

export const SubcountClassName = cn("flex rounded-md px-4 border-2 relative py-1 text-4xl")

export default function SubCount_client({ ytid, initialCount, className }: SubCountProps) {
    const [firstLoad, setFirstLoad] = useState(true)
    const [demoSubscribe, setDemoSubscribe] = useState(0)
    const [subCount, setSubCount] = useState(initialCount || 0);

    const { isLoading, data: ytData, isValidating } = useSocialUpdates(ytid);
    useEffect(() => {
        if (!ytData || //if not defined
            "error" in ytData || //if error
            !ytData.subcount || //if subcount is 0 / not defined
            ytData.subcount == subCount) //if no change to counter
            return;

        //set delay of 3 sec to allow initial animation to end
        //if already loaded no delay
        sleep(Number(firstLoad) * 3).then(() => {
            setSubCount(ytData.subcount);

            //if its first load - update state
            if (firstLoad)
                setFirstLoad(false)
        })
    }, [firstLoad, subCount, ytData])

    /** for first load - load subcount fast. for updates load slowly */
    const tickerSpeed = firstLoad && 20 || 100

    async function simulateSub() {
        //send event into google analytics
        if (ytData != undefined)
            GoogleAnalyticsEvent({
                event_name: "subscribe",
                event_label: !("error" in ytData) && ytData.name || ytid //add name / ytid
            })
        const url = `https://youtube.com/channel/${ytid}?sub_confirmation=1`;
        setDemoSubscribe((s) => s + 1);
        await sleep(1);
        window.open(url, '_blank');
        setDemoSubscribe((s) => s - 1);
    }

    return <Tooltip>
        <TooltipTrigger asChild>
            <div onMouseUp={ simulateSub } className={
                cn("flex-row sm:flex-col max-sm:gap-2 items-center justify-center transition-all cursor-pointer select-none",
                    "bg-red-600/70  border-red-300 text-shadow-sm hover:bg-red-600/90 hover:text-white",
                    "active:scale-90", SubcountClassName,
                    className)
                + " text-shadow-black/50" }>
                <NumberTicker
                    className=" leading-[0.85em]"
                    value={ subCount + Number(demoSubscribe) }
                    stiffness={ tickerSpeed }
                />
                { (isLoading || isValidating) && <Spinner className="text-[0.75em] absolute end-2 sm:end-[-1em] sm:-me-2" /> }
                <p className={ cn("text-[1em] leading-[0.85em]", font_title_secularOne.className) }>עוקבים</p>
            </div >
        </TooltipTrigger>
        <TooltipContent side="bottom" color="fill-red-600" className={ cn("border-red-600 text-xl", font_title_secularOne.className) }>
            הירשם לערוץ
        </TooltipContent>
    </Tooltip>
}